<template>
  <div>
    <SaveCanvas name="map-canvas">
      <GmapMap v-if="center" ref="mapRef" id="mapRef" class="map" :center="center" :zoom="17" map-type-id="terrain">
        <template v-if="markers.length">
          <GmapMarker :key="index" v-for="(m, index) in markers" :label="m.code" :position="m.position"
            :clickable="locked" :draggable="!locked" :optimized="false" :z-index="index + 99"
            @mouseup="moveMarker($event, m)" @click="showMarker(m)" />
        </template>
      </GmapMap>
    </SaveCanvas>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { SaveCanvas } from "@/components/core";
export default {
  components: { SaveCanvas },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    all: {
      type: Array,
      default: () => [],
    },
    exercise: {
      type: Object,
      default: () => { },
    },
    center: {
      type: Object,
      default: () => { },
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: false,
      },
      // places: [
      //   {
      //     id: "nha-trang",
      //     title: "Nha Trang",
      //     draggable: true,
      //     position: { lat: 12.2293071, lng: 109.2021254 },
      //   },
      //   {
      //     id: "da-nang",
      //     title: "Đà Nẵng",
      //     draggable: true,
      //     position: { lat: 16.1075166, lng: 108.1482611 },
      //   },
      //   {
      //     id: "nam-du",
      //     title: "Đảo Nam Du",
      //     draggable: true,
      //     position: { lat: 9.6852982, lng: 104.336686 },
      //   },
      // ],
    };
  },

  computed: {
    google: gmapApi,
    markers() {
      const arr = [...this.items];
      arr.map((x) => {
        x.position = {
          lat: x.position.lat !== 0 ? x.position.lat : this.center.lat,
          lng: x.position.lng !== 0 ? x.position.lng : this.center.lng,
        };
        x.draggable = true;
      });
      console.log("markers", arr);
      return arr;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.mapRef.$mapPromise.then((map) => {
        var bounds = this.google ? new this.google.maps.LatLngBounds() : null;
        if (bounds) {
          console.log("bounds", map);
        }
        this.markers.forEach((marker) => {
          let loc = new this.google.maps.LatLng(
            marker.position.lat,
            marker.position.lng
          );
          bounds.extend(loc);
        });
        if (bounds) {
          map.fitBounds(bounds);
        }
      });
    });
  },
  methods: {
    showMarker(marker) {
      this.$emit("showNote", marker);
    },
    getLabel(n) {
      const item = this.all.find((x) => x.id === n.id);
      console.log("index", this.all.indexOf(item));
      // return item ? String(this.all.indexOf(item)) : "N";
      return parseInt(this.all.indexOf(item));
    },
    moveMarker(evt, marker) {
      const position = {
        lat: evt.latLng.lat(),
        lng: evt.latLng.lng(),
      };
      this.$emit("updatedLngLat", { m: marker, p: position });
    },
  },
};
</script>

<style lang="scss">
.map {
  height: 80vh;
  width: 100%;
}
</style>
